import apiClient from "@/api/api-client";

export const addWordToDictionary = async (params) => {
  const { data } = await apiClient.post("/word/search", params);
  return data;
};

export const getDictionaryResult = async (filters) => {
  const { data } = await apiClient.get("/word/search", {
    params: filters,
  });
  return data;
};

export const deleteDictionary = async (params) => {
  const { data } = await apiClient.post("/word/search", params);
  return data;
};